(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
 'use strict';
 var T13={
  brakD:__pewniaki_inline_cfg[0],
  zakres:__pewniaki_inline_cfg[1],
  prog:__pewniaki_inline_cfg[2],
  brakP:__pewniaki_inline_cfg[3],
  ocena:__pewniaki_inline_cfg[4],
  najz:__pewniaki_inline_cfg[5],
  wczyt:__pewniaki_inline_cfg[6],
  blad:__pewniaki_inline_cfg[7]
 };

 var initial=__pewniaki_inline_cfg[8], code=__pewniaki_inline_cfg[9], root=document.querySelector('[data-pasmo-strona]');
 var seq=0, pending=null;
 function valid(o){return o && !o.powod && Number.isInteger(o.losowan) && o.losowan>=0;}
 function number(v){return typeof v==='number' && Number.isFinite(v);}
 function fmt(v){return number(v)?v.toFixed(3).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','):'—';}
 function thresholds(o){return valid(o) && !o.testy_powod;}
 function put(s,t){root.querySelector(s).textContent=t;}
 function conclusions(o){
  if(!valid(o))return [T13.brakD];
  var list=[T13.zakres.replace('%1',o.losowan).replace('%2',fmt(o.max_z))];
  list.push(thresholds(o)&&number(o.c95)&&Array.isArray(o.poza)?T13.prog.replace('%1',fmt(o.c95)).replace('%2',o.poza.length):T13.brakP);return list;
 }
 function rows(o,liczby,m){
  if(!liczby || !Number.isInteger(m) || m<2)throw new Error('struktura');
  var all=[];
  for(var n=1;n<=m;n++){
   var r=liczby[n];if(!r||!Number.isInteger(r.hits)||r.hits<0||r.hits>o.losowan||!number(r.e)||!number(r.z))throw new Error('liczby');
   all.push({n:n,hits:r.hits,e:r.e,z:r.z});
  }
  all.sort(function(a,b){return Math.abs(b.z)-Math.abs(a.z)||a.n-b.n;});
  var body=root.querySelector('[data-pasmo-body]');body.replaceChildren();
  all.slice(0,10).forEach(function(r){
   var tr=document.createElement('tr');tr.setAttribute('data-pasmo-row',String(r.n));
   [r.n,r.hits,fmt(r.e),fmt(r.z),thresholds(o)&&number(o.c95)&&Array.isArray(o.poza)?(o.poza.indexOf(r.n)>=0?__pewniaki_inline_cfg[10]:__pewniaki_inline_cfg[11]):'—'].forEach(function(v,i){var td=document.createElement('td');if(i===0){var k=document.createElement('span');k.className=__pewniaki_inline_cfg[12]+code;k.textContent=String(v);td.setAttribute('data-sort',String(v));td.appendChild(k);}else td.textContent=String(v);tr.appendChild(td);});body.appendChild(tr);
  });
  put('[data-pasmo-status]',T13.najz.replace('%1',all[0].n).replace('%2',Math.min(10,m)).replace('%3',m));
 }
 function frequency(d){
  if(!pending){var request=fetch('/assets/json/db/'+code+'/analizy/czestotliwosc.json?v='+encodeURIComponent(d.policzono||'')).then(function(r){if(!r.ok)throw new Error('HTTP');return r.json();});pending=request;request.catch(function(){if(pending===request)pending=null;});}return pending;
 }
 function render(o,key,d){
  var id=++seq;d=d||initial;root.querySelector('[data-pasmo-body]').replaceChildren();
  put('[data-pasmo-n]',valid(o)?String(o.losowan):'—');
  ['max_z','c95','c99'].forEach(function(k){put('[data-a7-value="'+k+'"]',valid(o)&&(k==='max_z'||thresholds(o))?fmt(o[k]):'—');});
  put('[data-pasmo-poza]',thresholds(o)&&number(o.c95)&&Array.isArray(o.poza)?String(o.poza.length):'—');
  put('[data-pasmo-prog]',thresholds(o)&&number(o.c95)&&Array.isArray(o.poza)?T13.ocena:T13.brakP);
  put('[data-pasmo-status]',valid(o)?T13.wczyt:T13.brakD);
  if(!valid(o))return Promise.resolve();
  if(o.liczby){try{rows(o,o.liczby,d.pula);}catch(e){put('[data-pasmo-status]',__pewniaki_inline_cfg[13]);}return Promise.resolve();}
  return frequency(d).then(function(f){
   if(id!==seq)return;
   if(!f||!d.policzono||f.gra!==code||d.gra!==code||f.pula!==d.pula||f.typuje!==d.typuje||f.policzono!==d.policzono)throw new Error('wersja');
   var w=f.okna&&f.okna[key];if(!valid(w)||w.losowan!==o.losowan)throw new Error('zakres');rows(o,w.liczby,d.pula);
  }).catch(function(){if(id!==seq)return;pending=null;root.querySelector('[data-pasmo-body]').replaceChildren();put('[data-pasmo-status]',T13.blad);});
 }
 function sumYears(years){
  var m=initial.pula,k=initial.typuje,N=0,hits={};
  if(!Number.isInteger(m)||!Number.isInteger(k)||k<=0||k>=m||!Array.isArray(years)||!years.length)return null;
  for(var n=1;n<=m;n++)hits[n]=0;
  for(var y of years){
   if(!y||!Number.isInteger(y.losowan)||y.losowan<0||!y.main)return null;
   var total=0;for(var key in y.main){var v=y.main[key];if(!/^\d+$/.test(key)||+key<1||+key>m||!Number.isInteger(v)||v<0||v>y.losowan)return null;hits[+key]+=v;total+=v;}
   if(total!==y.losowan*k)return null;N+=y.losowan;
  }
  if(!N)return {powod:'brak_danych',losowan:0};
  var E=N*k/m,sd=Math.sqrt(E*(1-k/m)),max=0,liczby={};
  for(var num=1;num<=m;num++){var z=(hits[num]-E)/sd;max=Math.max(max,Math.abs(z));liczby[num]={hits:hits[num],e:E,z:z};}
  return {powod:null,losowan:N,max_z:max,c95:null,c99:null,poza:null,liczby:liczby};
 }
 window.PEWNIAKI_ANALIZA={plik:'/assets/json/db/'+code+'/analizy/model.json',wersja:initial.policzono,lata:'/assets/json/db/'+code+'/lata/',render:function(o,key,d){return render(o,key,d);},wnioski:function(o){return conclusions(o);},sumujLata:sumYears};
})();
})();
